import { OperatingSystemType } from '../../constants/OperatingSystemType';
import { capitalizeFirstLetter } from '../../helpers/DisplayHelpers';

export interface OperatingSystemTypeProps {
    type: string;
    name?: string;
    version?: string;
}

export const OperatingSystemTypeDisplay = ({ type, name, version }: OperatingSystemTypeProps) => {
    const icon = type === OperatingSystemType.Windows ? 'fa-windows' : type === OperatingSystemType.Linux ? 'fa-linux' : 'fa-question';
    const showTitle = name !== undefined && name !== null;

    return (
        <>
            <i title={showTitle ? name + ' - ' + version : ''} className={`fa ${icon}`}></i>&nbsp;{capitalizeFirstLetter(type)}
        </>
    );
};
